/*
 * Copyright © 2025 Gavin Sawyer. All rights reserved.
 */

export const enabledMessages: { [key in "Newsletter" | "Order updates" | "Promotions"]: boolean } = {
  "Newsletter":    false,
  "Order updates": true,
  "Promotions":    false,
};
